// 使用する変数のみに絞り込み
let WinW, WinH;
const breakPoint = 768;

function setInit() {
	/*  rainmaker-slider設定
	-----------------------------------------------------------------*/
	// ページ内に要素（.js-rainmaker-slider01）が存在する場合のみ初期化する
	if (document.querySelector('.js-rainmaker-slider01')) {
		let swiper_rainmaker01 = new Swiper('.js-rainmaker-slider01', {
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	}

	// ページ内に要素（.js-rainmaker-slider02）が存在する場合のみ初期化する
	if (document.querySelector('.js-rainmaker-slider02')) {
		let swiper_rainmaker02 = new Swiper('.js-rainmaker-slider02', {
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	}
}

// HTML（DOM）の読み込みが完全に終わってから setInit を実行する
document.addEventListener('DOMContentLoaded', () => {
	setInit();
});